// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2x7-q","notes":"Notes_notes__77HLV","note":"Notes_note__10REH","markdown":"Notes_markdown__3v5Y6"};